import React from 'react'

export default function HamburgerBarLeftSvg() {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.0781 2.80531C18.0781 2.36055 17.7176 2 17.2728 2H2.36426C1.9195 2 1.55895 2.36055 1.55895 2.80531C1.55895 3.25007 1.9195 3.61062 2.36426 3.61062H17.2728C17.7176 3.61062 18.0781 3.25007 18.0781 2.80531Z"
        fill="white"
      />
      <path
        d="M18.0781 15.1947C18.0781 14.7499 17.7176 14.3894 17.2728 14.3894H2.36426C1.9195 14.3894 1.55895 14.7499 1.55895 15.1947C1.55895 15.6395 1.9195 16 2.36426 16H17.2728C17.7176 16 18.0781 15.6395 18.0781 15.1947Z"
        fill="white"
      />
      <path
        d="M18.0774 6.93263C18.0774 6.48914 17.7179 6.12962 17.2744 6.12962H7.52349C7.08 6.12962 6.72048 6.48914 6.72048 6.93263C6.72048 7.37612 7.08 7.73565 7.52349 7.73565H17.2744C17.7179 7.73565 18.0774 7.37612 18.0774 6.93263Z"
        fill="white"
      />
      <path
        d="M18.0774 11.0624C18.0774 10.6189 17.7179 10.2594 17.2744 10.2594H7.52349C7.08 10.2594 6.72048 10.6189 6.72048 11.0624C6.72048 11.5059 7.08 11.8654 7.52349 11.8654H17.2744C17.7179 11.8654 18.0774 11.5059 18.0774 11.0624Z"
        fill="white"
      />
      <path
        d="M4.10434 11.7716L1.65323 9.23624C1.52705 9.10572 1.52705 8.8941 1.65323 8.76358L4.10434 6.22827C4.30789 6.01772 4.65594 6.16684 4.65594 6.46459V11.5352C4.65594 11.833 4.30789 11.9821 4.10434 11.7716Z"
        fill="white"
        className="arrow"
      />
    </svg>
  )
}
